import React, { Fragment } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import i18n from "i18next";
import { useTranslation } from 'react-i18next';

import {account} from './imageLanguageHandler/account.js'; 
import {agpranges} from './imageLanguageHandler/agpranges.js';  
import {agpprofiles} from './imageLanguageHandler/agpprofiles.js';
//import bolusdetails from './imageLanguageHandler/bolusdetails.jpg';  
import {daysgraph} from './imageLanguageHandler/daysgraph.js';  
import {daysdetails} from './imageLanguageHandler/daysdetails.js';   
import {datasources} from './imageLanguageHandler/datasources.js';  
import {notifications} from './imageLanguageHandler/notifications.js'; 
import {settings} from './imageLanguageHandler/settings.js';  
import {sharing} from './imageLanguageHandler/sharing.js'; 
import {statistic} from './imageLanguageHandler/statistic.js';

function Features() {
  const { t } = useTranslation('help');
  return (
    <Fragment>
      <h1>{t('Features')}</h1>
      <p>{t('Estimated reading time')} 7 {t('minutes.')}</p> 
      <section id="agp">
        <h2>{t('AGP Report')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Features-AGPChapter1')}
        </p>
        <p>
          <img 
            src={statistic[i18n.language]?.() || statistic['en']()}
            alt={t('Statistics')} 
          />
        </p>
        <p>
          {t('Features-AGPChapter2')} 
        </p>
        <p>
          {t('Features-AGPChapter3')} 
        </p>
        <p>
          {t('Features-AGPChapter4')}
        </p>
        <p>
          <img 
            src={agpranges[i18n.language]?.() || agpranges['en']()}
            alt={t('Graph adjustment options')} 
          />
        </p>
        <p>
          {t('Features-AGPChapter5')}
        </p>
        <p>
          {t('Features-AGPChapter6')} 
        </p>
        <p>
          {t('Features-AGPChapter7')} 
        </p>
        <p>
          <img 
            src={agpprofiles[i18n.language]?.() || agpprofiles['en']()}
            alt={t('Possibilities for editing the observation period')}
          />
        </p>
      </section>
      {/*
      <section id="insulin">
        <h2>{t('Insulin view')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Features-InsulinChapter1')}
        </p>
        <img src={bolusdetails} alt={t('Chart details)} />
      </section>
      <section id="nutrition">
        <h3>Ravinto</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section>
      <section id="exercise">
        <h3>Liikunta</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section>
      <section id="diary">
        <h3>Päiväkirja</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section> 
      */}
      <section id="day">
        <h2>{t('Daily view')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Features-DailyChapter1')} 
        </p>
        <p>
          <img 
            src={daysgraph[i18n.language]?.() || daysgraph['en']()}
            alt={t('Daily view graph')}
          />
        </p>
        <p>
          {t('Features-DailyChapter2')}
        </p>
        <p>
        {t('Features-DailyChapter3')} <Link
          to="/help/interpretation#images">{t('Add meal photos')}</Link>{t('Features-DailyChapter3End')}
        </p>
        <p>
          <img 
            src={daysdetails[i18n.language]?.() || daysdetails['en']()}
            alt={t('Daily view details')}
          />
        </p>
      </section>
      <section id="settings">
        <h2>{t('Notifications and settings')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link> 
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter1')}
        </p>
        <p>
          <img 
            src={notifications[i18n.language]?.() || notifications['en']()}
            alt={t('Notifications')} 
          />
        </p>
        <p>
        {t('Features-NotificationsAndSettingsChapter2')}
        </p>
        <p>
          <img 
            src={settings[i18n.language]?.() || settings['en']()}
            alt={t('Settings')}
          />
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter3')}
        </p>
        <p>
          <img 
            src={account[i18n.language]?.() || account['en']()}
            alt={t('Profile settings')}  
          />
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter4')} 
        </p>
        <p>
        {t('Features-NotificationsAndSettingsChapter5')} <Link to="/help/interpretation">{t('Interpretation')}</Link>{t('Features-NotificationsAndSettingsChapter5End')}
        </p>
        <p>
          <img 
            src={datasources[i18n.language]?.() || datasources['en']()}
            alt={t('Data sources')}  
          />
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter6')} 
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter7')}
        </p>
        <p>
          {t('Features-NotificationsAndSettingsChapter8')}
        </p>
        <p>
          <img 
            src={sharing[i18n.language]?.() || sharing['en']()}
            alt={t('Sharing')} 
          />
        </p>
      </section>
    </Fragment>
  );
}

export default Features;